import React, {ReactNode, Suspense, memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type LinkProps = {
    href: string
    children: ReactNode
    dataGaV1?: string
    dataGaV2?: string
    rel?: string
    dataTestId?: string
    alignTop?: boolean
    mainTemplate: string
    fallbackTemplate: string
}

// Todo: User Story 385091 - Use global link package
// https://dev.azure.com/Next-Technology/Ecom.Backlog/_workitems/edit/385091
const Link = memo((props: LinkProps) => {
    const {mainTemplate, fallbackTemplate} = props
    const ComponentName = useTemplatedComponent({mainTemplate, fallbackTemplate}, MANIFEST)

    return (
        <Suspense>
            <ComponentName {...props} />
        </Suspense>
    )
})
Link.displayName = "Link"

export default connect(Link)
